import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";

const randomNumBetween = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const getRandomProjects = (projects: Project[]): Project[] => {
  const results = new Set<Project>();

  while (results.size < projects.length) {
    const randomIndex = randomNumBetween(0, projects.length - 1);
    results.add(projects[randomIndex]);
  }

  return Array.from(results);
};
